import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { MObjectifMAPHeader, translateHeaders } from './helpers/HeadersList';
import { requireTitle } from './helpers/utils';
import Grid from '../Grid';
import { eanValidator, listValidator } from '../Validators';
import { AutoCompleteRenderer } from './helpers/customRenderers';
import ValidationRenderer from '../CellRenderers/ValidationRenderers';

export const MObjectifMAP: FC<{
    list: IList;
    toolId: number;
    retailers: string[];
}> = ({ list, toolId, retailers }) => {
    const translatedHeaders = translateHeaders(MObjectifMAPHeader);

    return (
        <Grid toolId={toolId} headers={MObjectifMAPHeader} list={list}>
            <HotColumn
                title={requireTitle(translatedHeaders[0])}
                validator={listValidator(retailers)}
                source={retailers}
                type="autocomplete"
            >
                <AutoCompleteRenderer list={retailers} hot-renderer />
            </HotColumn>
            <HotColumn title={requireTitle(translatedHeaders[1])} validator={eanValidator(false)} />
            <HotColumn allowEmpty={false} type="numeric" title={requireTitle(translatedHeaders[2])} />
        </Grid>
    );
};
